import { graphql } from 'src/graphql';

export const CollectionViews = graphql(`
  query CollectionViews($code: String, $id: ID) {
    collection(filter: { code: $code, _id: $id }) {
      _id
      views {
        email
        count
        lastViewedAt
      }
    }
  }
`);
